import { render } from "./PaginaLegal.vue?vue&type=template&id=140be76c&scoped=true"
import script from "./PaginaLegal.vue?vue&type=script&lang=js"
export * from "./PaginaLegal.vue?vue&type=script&lang=js"

import "./PaginaLegal.vue?vue&type=style&index=0&id=140be76c&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140be76c"]])

export default __exports__